<template>
  <div :class="isDetail ? 'ly-no-data detail' : 'ly-no-data'">
    <p class="text">본 작업 결과<br>
              작업자<br>
              지석빈[목동1]<br>
              작업 일시<br>
              2021-12-15 (00:00:47)<br>
              작업 결과<br><br>
              [ 실행 장비 : CA071 ]<br><br>
              MDIDC-CA071-C1#<br>
              MDIDC-CA071-C1#terminal length 0<br>
              MDIDC-CA071-C1#!! [CA071] !!_QoS work<br>
              MDIDC-CA071-C1#<br>
              MDIDC-CA071-C1#config t<br>
              Enter configuration commands, one per line. End with CNTL/Z.<br>
              MDIDC-CA071-C1(config)#<br>
              MDIDC-CA071-C1(config)#interface GigabitEthernet7/35<br>
              MDIDC-CA071-C1(config-if)# no service-policy input 100M<br>
              MDIDC-CA071-C1(config-if)# service-policy input 300M<br>
              MDIDC-CA071-C1(config-if)#end<br>
              MDIDC-CA071-C1#<br>
              **********************************************************************
      </p>

  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.ly-no-data {
  display: flex;
  margin : {
    top: 5px;
    bottom: 5px;
  }
  height: 98%;
  align-items: center;
  justify-content: center;
  background: $--color-white-smoke;
  border-radius: 10px;
  .text {
    width: 325px;
    line-height: 26px;
    font-size: $--font-size-base;
    color: $--text-nodata;
    text-align: center;
  }
  &.detail {
    height: calc(100vh - 280px);
    
  }
}
</style>
